import React from 'react';

const CriticalErrorPopup = ({ 
  isOpen, 
  title = "Critical Error", 
  message, 
  details = null,
  onClose = null, // If null, popup is inescapable
  showHomeButton = false,
  homeButtonText = "Go Home",
  onHomeClick = null,
  showReloadButton = false,
  reloadButtonText = "Reload Page",
  onReloadClick = null
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(4px)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
        border: '2px solid #dc3545',
        textAlign: 'center',
        position: 'relative'
      }}>
        {/* Error Icon */}
        <div style={{
          fontSize: '48px',
          color: '#dc3545',
          marginBottom: '16px'
        }}>
          ⚠️
        </div>
        
        {/* Title */}
        <h2 style={{
          margin: '0 0 16px 0',
          color: '#dc3545',
          fontSize: '24px',
          fontWeight: '700'
        }}>
          {title}
        </h2>
        
        {/* Message */}
        <p style={{
          margin: '0 0 16px 0',
          color: '#333',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        
        {/* Details */}
        {details && (
          <div style={{
            margin: '16px 0',
            padding: '12px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            border: '1px solid #dee2e6',
            fontSize: '14px',
            color: '#6c757d',
            textAlign: 'left'
          }}>
            {details}
          </div>
        )}
        
        {/* Button Container */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          marginTop: '16px',
          flexWrap: 'wrap'
        }}>
          {/* Home Button (if enabled) */}
          {showHomeButton && onHomeClick && (
            <button
              onClick={onHomeClick}
              style={{
                backgroundColor: '#1d4e89',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#153d6b'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#1d4e89'}
            >
              🏠 {homeButtonText}
            </button>
          )}
          
          {/* Reload Button (if enabled) */}
          {showReloadButton && onReloadClick && (
            <button
              onClick={onReloadClick}
              style={{
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
            >
              🔄 {reloadButtonText}
            </button>
          )}
          
          {/* Close Button (only if onClose is provided) */}
          {onClose && (
            <button
              onClick={onClose}
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#c82333'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#dc3545'}
            >
              Close
            </button>
          )}
        </div>
        
        {/* Inescapable indicator */}
        {!onClose && !showHomeButton && !showReloadButton && (
          <div style={{
            marginTop: '16px',
            fontSize: '14px',
            color: '#6c757d',
            fontStyle: 'italic'
          }}>
            This error cannot be dismissed
          </div>
        )}
      </div>
    </div>
  );
};

export default CriticalErrorPopup;
